// latest: zhangmyh 2017-8-2 7:20 PM
// 资质库参照
import Collection from 'common/vo/collection'
import 'collection/certification'
import 'collection/certification/certificationClass'
import { findIndex } from 'lodash'
import { Get } from 'common'
/* global $ u */

let _config
async function init (refer) {
  // 树形控件加载有误,所以需要每次都重新加载
  let collection = Collection.create('certification.list')
  let tree = Collection.create('collection.certificationClass')
  let selectedData = []
  let selectflag = false

  let data = await Get('/cpu-supplymgr/certificationClass/selectCertificationClassByCondition?type=' + _config.parentId)
  let data2 = []
  for (let i = 0; i < data.data.length; i++) {
    let x = {
      id: data.data[i].id,
      pid: data.data[i].parentId,
      title: data.data[i].name,
      code: data.data[i].code,
      innercode: data.data[i].innercode,
      open: false
    }
    data2.push(x)
  }
  tree.datatable.removeAllRows()
  tree.datatable.setSimpleData(data2)
  let vm = {
    treemodel: tree.datatable,
    treeOption: {
      callback: {
        beforeClick: async function (id, obj) {
          collection.datatable.removeAllRows()
          collection.load({
            status: 0,
            type: _config.parentId,
            classId: obj.id
          })
        }
      }
    },
    gridconfig: {
      id: 'gridcertification',
      data: collection,
      type: 'grid',
      multiSelect: _config.multiSelect,
      editable: false,
      pagination: true,
      fields: (function () {
        if (_config.parentId == 0) {
          return [{
            'field': 'code',
            'dataType': 'String',
            'title': '指标编码',
            'width': '33.3%',
            renderType (obj) {
              obj.element.innerHTML = buildDetailHtml(obj.row.value.code, obj.row.value)
            }
          }, {
            'field': 'name',
            'dataType': 'String',
            'title': '指标名称',
            'width': '33.3%',
            renderType (obj) {
              obj.element.innerHTML = buildDetailHtml(obj.row.value.name, obj.row.value)
            }
          }, {
            'field': 'indicatorTypeShowName',
            'dataType': 'String',
            'title': '指标类型',
            'width': '33.3%',
            renderType (obj) {
              obj.element.innerHTML = buildDetailHtml(obj.row.value.indicatorTypeShowName, obj.row.value)
            }
          }]
        } else if (_config.parentId == 1) {
          return [{
            'field': 'code',
            'dataType': 'String',
            'title': '指标编码',
            'width': '50%',
            renderType (obj) {
              obj.element.innerHTML = buildDetailHtml(obj.row.value.code, obj.row.value)
            }
          }, {
            'field': 'name',
            'dataType': 'String',
            'title': '指标名称',
            'width': '50%',
            renderType (obj) {
              obj.element.innerHTML = buildDetailHtml(obj.row.value.name, obj.row.value)
            }
          }]
        }
      })()
    }
  }

  let app = u.createApp()
  app.init(vm, $('#tplindicator_refer')[0])
  refer.registerSubmitFunc(() => {
    return selectedData
  })

  collection.on('data', function (result) {
    selectflag = false
    if (_config.multiSelect && !_config.repeatable && refer.options.defaultData) {
      if (selectedData.length <= 0) {
        // 初始化默认值
        let defaultData = refer.options.defaultData()
        if (defaultData instanceof Array) {
          selectedData = defaultData
        }
      }

      let SelectIndex = []
      if (result.data && result.data.data && result.data.data.length > 0) {
        result.data.data.forEach(function (listItem, i) {
          selectedData.forEach(function (item) {
            if (item.id === listItem.id) {
              SelectIndex.push(i)
            }
          })
        })
      }
      collection.datatable.setRowsSelect(SelectIndex)
    }
    selectflag = true
  })

  collection.datatable.on('unSelect', function (obj) {
    let selectData = collection.datatable.getRowByRowId(obj.rowIds[0])
    let index = findIndex(selectedData, ['id', selectData.data.id.value])
    if (index >= 0) {
      selectedData.splice(index, 1)
    }
  })

  collection.datatable.on('select', function (obj) {
    if (!_config.multiSelect) {
      let selectData = collection.datatable.getCurrentRow().getSimpleData()
      let filepath = selectData.filePath.value
      if (!filepath) {
        filepath = ''
      }
      selectedData = {
        id: selectData.id,
        classId: selectData.classId,
        className: selectData.className,
        description: selectData.description,
        name: selectData.name,
        scoreBasis: selectData.scoreBasis,
        indicatorType: selectData.indicatorType,
        url: filepath
      }
      refer.submit()
      return
    }
    // 默认初始化已选择数据的时候不触发数据改变
    if (selectflag) {
      let selectArray = collection.getSelected()
      let selectData = selectArray[selectArray.length - 1]
      let index = findIndex(selectedData, ['id', selectData.id.value])
      if (index >= 0) {
        return
      }
      let filepath = selectData.filePath ? selectData.filePath.value : ''
      if (!filepath) {
        filepath = ''
      }
      selectedData.push({
        id: selectData.id,
        classId: selectData.classId,
        className: selectData.className,
        description: selectData.description,
        name: selectData.name,
        scoreBasis: selectData.scoreBasis,
        indicatorType: selectData.indicatorType,
        url: filepath
      })
    }
  })
}

let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    parentId: 0,
    canRemoveBasic: false,
    multiSelect: true,
    repeatable: false
  }, config)

  return {
    init,
    template
  }
}

function buildDetailHtml (currAttr, objValue) {
  let result = ''
  result += '<span title="'
  result += '指标编码: ' + objValue.code + '\n'
  result += '指标名称: ' + objValue.name + '\n'
  result += '指标描述: ' + objValue.description + '\n'
  result += '评分依据: ' + objValue.scoreBasis + '\n'
  result += '">'
  result += currAttr
  result += '</span>'
  return result
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/tplindicator/index.js